export const AI_TOGGLES = [
  { l: 'Auto-detect scheduling conflicts', d: 'AI monitors timetable and flags issues in real time', on: true },
  { l: 'Auto-suggest conflict resolutions', d: 'AI proposes fixes when a conflict is detected', on: true },
  { l: 'Generate course descriptions with AI', d: 'AI drafts descriptions when courses are created', on: true },
  { l: 'AI compliance pre-check before submission', d: 'Validates EduTrust, STB, and SSF before plan goes to Head', on: true },
  { l: 'AI-generated approval summaries', d: 'AI drafts academic head summary reports', on: false },
];

export const NOTIFICATION_TOGGLES = [
  { l: 'Conflict alerts (AI-detected)', d: 'Immediate notification on scheduling conflict', on: true },
  { l: 'STB licence expiry warnings', d: '90 days before a guide trainer licence expires', on: true },
  { l: 'Approval workflow updates', d: 'When plan status changes at any stage', on: true },
  { l: 'AI Agent action log', d: 'Notification when AI automatically resolves an issue', on: true },
  { l: 'Weekly deployment summary', d: 'Every Monday at 8:00 AM SGT', on: true },
  { l: 'EduTrust audit reminders', d: '30 days before submission deadline', on: true },
];

export const INTEGRATIONS = [
  // var(--sky) flips light<->dark the same way var(--sea)/var(--ocean)/var(--green)
  // below do — paired with the icon's var(--surface) foreground (SettingsPage.js)
  // that keeps a wide contrast gap in both themes. A fixed hex here (e.g. #1D4ED8)
  // would not: paired with --surface's near-black in dark mode it drops to ~3.6:1.
  { n: 'AI Agent', i: 'fa-robot', c: 'var(--sky)', s: 'Connected' },
  { n: 'STB Licensing API', i: 'fa-id-badge', c: 'var(--sea)', s: 'Connected' },
  { n: 'SkillsFuture SWDA Portal', i: 'fa-graduation-cap', c: 'var(--ocean)', s: 'Connected' },
  { n: 'EduTrust Audit Export', i: 'fa-shield-check', c: 'var(--green)', s: 'Connected' },
  { n: 'Meta Business Suite', i: 'fa-hashtag', c: 'var(--coral)', s: 'Pending' },
];
